import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from '../styles/HomePageWeb.module.css';
import Header from './common/Header';
import Footer from './common/Footer';
import SignInPopUp from './SignInPopUp';
import SignUpPopUp from './SignUpPopUp';
// import gamStar from '../assets/gam_star.png';

// Import SVG assets
import sunartboard from '../assets/svg/sunartboard-2-1.svg';
import horoscopeBg from '../assets/svg/horoscope-bg-1.svg';
import lineRoundedArrow from '../assets/svg/line-rounded-arrow-right-1.svg';
import frame2072750105 from '../assets/svg/frame-2072750105.svg';
import frame20727501051 from '../assets/svg/frame-2072750105-1.svg';
import iconParkRight3 from '../assets/svg/icon-park-right-3.svg';
import iconParkRight4 from '../assets/svg/icon-park-right-4.svg';
import iconParkRight7 from '../assets/svg/icon-park-right-7.svg';
import iconParkRight8 from '../assets/svg/icon-park-right-8.svg';
import iconParkRight9 from '../assets/svg/icon-park-right-9.svg';
import iconParkRight17 from '../assets/svg/icon-park-right-17.svg';
import line8 from '../assets/svg/line-8.svg';
import line81 from '../assets/svg/line-8-1.svg';
import starsSvg from '../assets/svg/stars-svgrepo-com.svg';
import planetSvg from '../assets/svg/planet-svgrepo-com.svg';

// Import PNG assets
import consultationIcon from '../assets/consultation-icon.png';
import horoscopeIcon from '../assets/horoscope-icon.png';
import astrologyCoursesIcon from '../assets/astrology-courses-icon.png';
import decorativeStar from '../assets/decorative-star.png';

const TESTIMONIALS = [
  {
  quote:
  "सरांच्या सखोल ज्योतिषज्ञानामुळे आमच्या कुटुंबाला नेहमीच अचूक आणि उपयुक्त मार्ग मिळाला. खूप आभारी आहोत.",
  name: "सौ. मंजिरी जोशी",
  role: "Renowned Research Scientist"
  },
  {
  quote:
  "Mr. Kelkar has been our family's trusted mentor for decades — accurate, insightful, and deeply practical.",
  name: "Govardhan Bihani",
  role: "Ahilyanagar"
  },
  {
  quote:
  "Consulting Suneel Kelkar Sir changed my life. His predictions and remedies brought clarity and positive change.",
  name: "Aditya Oke",
  role: "Renowned Graphologist & Vaastu Consultant"
  },
  {
  quote:
  "His gold/silver forecasts and market-cycle insights are consistently precise — invaluable for my investments.",
  name: "Market Client",
  role: "Investor"
  },
  {
  quote:
  "Accurate guidance on career, health, home and finances — always timely and practical.",
  name: "Mayur Datar",
  role: "Chartered Accountant"
  },
  {
  quote:
  "Clear, consistent, actionable market guidance — one of the biggest reasons I've stayed active in markets.",
  name: "Mr. Atul Vyas",
  role: "Senior Portfolio Management Consultant"
  },
  {
  quote:
  "Since 2006, Shri Suneel Kelkar's accurate predictions, practical remedies, and mentorship have profoundly shaped my life and career.",
  name: "Mr. Aashish Kulkarni",
  role: "Senior VP, Cyber Security Leader"
  }
];

export default function HomePage() {
  const navigate = useNavigate();
  const [openFaqs, setOpenFaqs] = useState(new Set());
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);

  // Slider states
  const [currentTestimonialSlide, setCurrentTestimonialSlide] = useState(0);
  const [currentCourse, setCurrentCourse] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  const totalTestimonials = TESTIMONIALS.length;
  const totalCourses = 3;

  // Calculate cards per slide based on viewport
  const isMobile = windowWidth < 768;
  const cardsPerSlide = isMobile ? 1 : 3;
  const totalTestimonialSlides = Math.ceil(totalTestimonials / cardsPerSlide);

  useEffect(() => {
    const baseHeight = 4750;
    const additionalHeight = openFaqs.size * 70;
    const totalHeight = baseHeight + additionalHeight;

    document.documentElement.style.setProperty('--page-height', `${totalHeight}px`);
  }, [openFaqs]);

  // Track window width for responsive slider and reset slide index on resize
  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      const wasMobile = windowWidth < 768;
      const isNowMobile = newWidth < 768;

      setWindowWidth(newWidth);

      // Reset to first slide when switching between mobile/desktop to avoid out-of-bounds
      if (wasMobile !== isNowMobile) {
        setCurrentTestimonialSlide(0);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [windowWidth]);

  const toggleFaq = (faqId) => {
    const newOpenFaqs = new Set(openFaqs);
    if (newOpenFaqs.has(faqId)) {
      newOpenFaqs.delete(faqId);
    } else {
      newOpenFaqs.add(faqId);
    }
    setOpenFaqs(newOpenFaqs);
  };

  const handleSignInOpen = () => {
    setIsSignInOpen(true);
  };

  const handleSignInClose = () => {
    setIsSignInOpen(false);
  };

  const handleSignUpOpen = () => {
    setIsSignInOpen(false); // Close sign-in popup
    setIsSignUpOpen(true);  // Open sign-up popup
  };

  const handleSignUpClose = () => {
    setIsSignUpOpen(false);
  };

  const handleNavigateToSignIn = () => {
    setIsSignUpOpen(false); // Close sign-up popup
    setIsSignInOpen(true);  // Open sign-in popup
  };

  const handleNavigateToHoroscope = () => {
    navigate('/horoscope');
  };

  const handleNavigateToConsultation = () => {
    navigate('/consultation');
  };

  const handleNavigateToAstrology = () => {
    navigate('/astrology');
  };

  // Testimonial slider navigation with wrapping
  const nextTestimonial = () => {
    setCurrentTestimonialSlide((prev) => (prev + 1) % totalTestimonialSlides);
  };

  const prevTestimonial = () => {
    setCurrentTestimonialSlide((prev) => (prev - 1 + totalTestimonialSlides) % totalTestimonialSlides);
  };

  // Course slider navigation
  const nextCourse = () => {
    setCurrentCourse((prev) => (prev + 1) % totalCourses);
  };

  const prevCourse = () => {
    setCurrentCourse((prev) => (prev - 1 + totalCourses) % totalCourses);
  };

  // Touch event handlers for swipe gestures
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = (type) => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50;

    if (Math.abs(distance) < minSwipeDistance) return;

    if (type === 'testimonial') {
      if (distance > 0) {
        nextTestimonial();
      } else {
        prevTestimonial();
      }
    } else if (type === 'course') {
      if (distance > 0) {
        nextCourse();
      } else {
        prevCourse();
      }
    }

    setTouchStart(0);
    setTouchEnd(0);
  };

  return (
    <>
      <Header activePage="home" onNavigateToSignIn={handleSignInOpen} />

      {/* Gam Star positioned below header */}
{/*       <div className="decorative-star right-star"> */}
{/*         <img src={gamStar} alt="Decorative Star" className="gam-star" /> */}
{/*       </div> */}

      <main className={styles['home-page-web']} data-model-id="1:293">
        <div className={styles.ellipse} aria-hidden="true"></div>
        <img
          className={styles.sunartboard}
          src={sunartboard}
          alt="Decorative sun artwork"
        />
        <img
          className={styles['horoscope-bg']}
          src={horoscopeBg}
          alt="Horoscope background design"
        />
        <section className={styles.CTA}>
          <Link to="/consultation" className={styles['book-a-reading']} role="button" aria-label="Book a reading session">
            <span className={styles['button-text']}>BOOK A READING</span>
            <img
              className={styles['line-rounded-arrow']}
              src={lineRoundedArrow}
              alt=""
              aria-hidden="true"
            />
          </Link>
          <Link to="/astrology" className={styles['learn-astrology']} role="button" aria-label="Learn astrology courses">
            <span className={styles['text-wrapper']}>LEARN ASTROLOGY</span>
          </Link>
        </section>
        <h1 className={styles.heading}>Discover your cosmic path</h1>
        <p className={styles.paragraph}>
          Discover the secrets of the stars with our personalized astrology readings. Explore your zodiac sign, daily
          horoscopes, and celestial insights. Unlock the mysteries of the universe and find your true path.
        </p>
        <section className={styles.frame}>
          <div className={styles.div}>
            <header className={styles['frame-2']}>
              <h2 className={styles['text-wrapper-2']}>Our Services</h2>
              <img
                className={styles.img}
                src={frame2072750105}
                alt="Decorative divider"
                aria-hidden="true"
              />
            </header>
            <div className={styles['frame-3']}>
              <article className={styles['frame-4']} onClick={handleNavigateToConsultation} style={{ cursor: 'pointer' }}>
                <div className={styles.rectangle} aria-hidden="true">
                    <img
                      className={styles.group}
                      src={consultationIcon}
                      alt="General consultation icon"
                    />
                </div>
                <h3 className={styles['text-wrapper-3']}>General consultation</h3>
              </article>
              <article className={styles['frame-5']} onClick={handleNavigateToHoroscope} style={{ cursor: 'pointer' }}>
                <div className={styles.rectangle} aria-hidden="true">
                    <img
                      className={styles['group-2']}
                      src={horoscopeIcon}
                      alt="Horoscope reading icon"
                    />
                </div>
                <h3 className={styles['text-wrapper-4']}>Horoscope reading</h3>
              </article>
              <article className={styles['frame-5']} onClick={handleNavigateToAstrology} style={{ cursor: 'pointer' }}>
                <div className={styles.rectangle} aria-hidden="true">
                    <img
                      className={styles['group-3']}
                      src={astrologyCoursesIcon}
                      alt="Astrology courses icon"
                    />
                </div>
                <h3 className={styles['text-wrapper-5']}>Astrology courses</h3>
              </article>
            </div>
          </div>
          <section className={styles['frame-6']}>
            <header className={styles['frame-7']}>
              <div className={styles['frame-2']}>
                <h2 className={styles['text-wrapper-6']}>Testimonials</h2>
                <img
                  className={styles['frame-8']}
                  src={frame20727501051}
                  alt="Decorative divider"
                  aria-hidden="true"
                />
              </div>
              <p className={styles['text-wrapper-7']}>What our clients say</p>
            </header>
            <div className={styles.testimonials}>
              <button
                className={styles['testimonial-nav-btn']}
                aria-label="Previous testimonials"
                onClick={prevTestimonial}
              >
                <img src={iconParkRight3} alt="" />
              </button>
              <div className={styles['testimonial-slider-container']}>
                <div
                  className={styles['testimonial-slider-track']}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={() => handleTouchEnd('testimonial')}
                  style={{
                    transform: `translateX(-${currentTestimonialSlide * 100}%)`,
                    transition: 'transform 0.3s ease-in-out'
                  }}
                >
                  {TESTIMONIALS.map((testimonial, idx) => (
                    <article key={idx} className={styles['testimonial-card']}>
                      <div className={styles.card}>
                        <span className={styles['text-wrapper-8']} aria-hidden="true">"</span>
                        <blockquote className={styles.testimonial}>
                          {testimonial.quote}
                        </blockquote>
                        <cite className={styles['testimonal-name']}>{testimonial.name}</cite>
                        <p className={styles['testimonial-role']}>{testimonial.role}</p>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
              <button
                className={styles['testimonial-nav-btn']}
                aria-label="Next testimonials"
                onClick={nextTestimonial}
              >
                <img src={iconParkRight4} alt="" />
              </button>
            </div>

            {/* Dot navigation indicators */}
            <div className={styles['testimonial-dots']}>
              {[...Array(totalTestimonialSlides)].map((_, index) => (
                <button
                  key={index}
                  className={`${styles['dot']} ${index === currentTestimonialSlide ? styles['dot-active'] : ''}`}
                  onClick={() => setCurrentTestimonialSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {/* White star SVG positioned at left bottom corner of testimonial section */}
            <svg
              className={styles['testimonial-white-star']}
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
              aria-hidden="true"
            >
              <g opacity="0.5" clipPath="url(#clip0_1_810)">
                <path d="M28.7138 23.4265C29.1263 22.189 30.8738 22.189 31.2863 23.4265L33.705 30.6902C34.2374 32.287 35.1344 33.7378 36.3249 34.9277C37.5154 36.1175 38.9667 37.0137 40.5638 37.5452L47.8238 39.964C49.0613 40.3765 49.0613 42.124 47.8238 42.5365L40.56 44.9552C38.9633 45.4876 37.5125 46.3846 36.3226 47.5751C35.1328 48.7657 34.2365 50.2169 33.705 51.814L31.2863 59.074C31.1973 59.345 31.0251 59.5809 30.7941 59.7482C30.5631 59.9155 30.2852 60.0056 30 60.0056C29.7148 60.0056 29.4369 59.9155 29.2059 59.7482C28.975 59.5809 28.8027 59.345 28.7138 59.074L26.295 51.8102C25.763 50.2139 24.8666 48.7634 23.6767 47.5735C22.4869 46.3837 21.0364 45.4873 19.44 44.9552L12.1763 42.5365C11.9053 42.4476 11.6693 42.2753 11.502 42.0443C11.3347 41.8134 11.2447 41.5354 11.2447 41.2502C11.2447 40.965 11.3347 40.6871 11.502 40.4562C11.6693 40.2252 11.9053 40.0529 12.1763 39.964L19.44 37.5452C21.0364 37.0132 22.4869 36.1168 23.6767 34.927C24.8666 33.7371 25.763 32.2866 26.295 30.6902L28.7138 23.4265ZM14.2275 4.30524C14.2813 4.14285 14.3849 4.00153 14.5236 3.90137C14.6622 3.8012 14.829 3.74729 15 3.74729C15.1711 3.74729 15.3378 3.8012 15.4765 3.90137C15.6152 4.00153 15.7187 4.14285 15.7725 4.30524L17.2238 8.66274C17.8725 10.6052 19.395 12.1277 21.3375 12.7765L25.695 14.2277C25.8574 14.2815 25.9987 14.3851 26.0989 14.5238C26.1991 14.6625 26.253 14.8292 26.253 15.0002C26.253 15.1713 26.1991 15.338 26.0989 15.4767C25.9987 15.6154 25.8574 15.719 25.695 15.7727L21.3375 17.224C20.3795 17.5432 19.509 18.0811 18.7949 18.7951C18.0809 19.5092 17.543 20.3797 17.2238 21.3377L15.7725 25.6952C15.7187 25.8576 15.6152 25.999 15.4765 26.0991C15.3378 26.1993 15.1711 26.2532 15 26.2532C14.829 26.2532 14.6622 26.1993 14.5236 26.0991C14.3849 25.999 14.2813 25.8576 14.2275 25.6952L12.7763 21.3377C12.4571 20.3797 11.9192 19.5092 11.2051 18.7951C10.4911 18.0811 9.62055 17.5432 8.66252 17.224L4.30502 15.7727C4.14263 15.719 4.00131 15.6154 3.90114 15.4767C3.80098 15.338 3.74707 15.1713 3.74707 15.0002C3.74707 14.8292 3.80098 14.6625 3.90114 14.5238C4.00131 14.3851 4.14263 14.2815 4.30502 14.2277L8.66252 12.7765C9.62055 12.4573 10.4911 11.9194 11.2051 11.2053C11.9192 10.4913 12.4571 9.62078 12.7763 8.66274L14.2275 4.30524ZM40.7363 0.371494C40.7733 0.264718 40.8427 0.172129 40.9347 0.1066C41.0268 0.0410715 41.137 0.00585937 41.25 0.00585938C41.363 0.00585938 41.4732 0.0410715 41.5653 0.1066C41.6574 0.172129 41.7268 0.264718 41.7638 0.371494L42.7313 3.27399C43.1625 4.57149 44.1788 5.58774 45.4763 6.01899L48.3788 6.98649C48.4855 7.02351 48.5781 7.09288 48.6437 7.18496C48.7092 7.27703 48.7444 7.38723 48.7444 7.50024C48.7444 7.61326 48.7092 7.72346 48.6437 7.81553C48.5781 7.90761 48.4855 7.97698 48.3788 8.014L45.4763 8.98149C44.8369 9.19421 44.2558 9.55306 43.7793 10.0296C43.3028 10.5061 42.944 11.0871 42.7313 11.7265L41.7638 14.629C41.7268 14.7358 41.6574 14.8284 41.5653 14.8939C41.4732 14.9594 41.363 14.9946 41.25 14.9946C41.137 14.9946 41.0268 14.9594 40.9347 14.8939C40.8427 14.8284 40.7733 14.7358 40.7363 14.629L39.7688 11.7265C39.5561 11.0871 39.1972 10.5061 38.7207 10.0296C38.2442 9.55306 37.6632 9.19421 37.0238 8.98149L34.125 8.014C34.0182 7.97698 33.9257 7.90761 33.8601 7.81553C33.7946 7.72346 33.7594 7.61326 33.7594 7.50024C33.7594 7.38723 33.7946 7.27703 33.8601 7.18496C33.9257 7.09288 34.0182 7.02351 34.125 6.98649L37.0275 6.01899C38.325 5.58774 39.3413 4.57149 39.7725 3.27399L40.7363 0.375244V0.371494Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_1_810">
                  <rect width="60" height="60" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </section>
          <img className={styles.line} src={line8} alt="" aria-hidden="true" />
          <img
            className={styles['stars-svgrepo-com']}
            src={starsSvg}
            alt="Decorative stars"
            aria-hidden="true"
          />
          <img
            className={styles['planet-svgrepo-com']}
            src={planetSvg}
            alt="Decorative planet"
            aria-hidden="true"
          />
        </section>
        <img className={styles['line-2']} src={line81} alt="" aria-hidden="true" />
        <h2 className={styles['heading-2']}>Check out our best-selling courses</h2>
        <div className={styles['courses-container-wrapper']}>
          <div className={styles['courses-slider-container']} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '0 20px' }}>
            <button
              className={styles['course-nav-btn']}
              aria-label="Previous course"
              onClick={prevCourse}
              style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '8px', display: 'none' }}
            >
              <img src={iconParkRight3} alt="" style={{ width: '32px', height: '32px' }} />
            </button>
            <div style={{ overflow: 'hidden', width: '100%', maxWidth: '1200px' }}>
              <section
                className={styles['frame-12']}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={() => handleTouchEnd('course')}
                style={{
                  transform: `translateX(-${currentCourse * 100}%)`,
                  transition: 'transform 0.3s ease-in-out'
                }}
              >
          <article className={styles['div-6']}>
            <div className={styles['frame-13']}>
              <div className={styles['frame-14']}>
                <span className={styles['text-wrapper-22']}>₹ 490</span>
              </div>
              <div className={styles['frame-15']}>
                <span className={styles['text-wrapper-23']}>Beginner</span>
              </div>
            </div>
            <div className={styles['frame-16']}>
              <h3 className={styles['text-wrapper-24']}>Introduction to Zodiac Signs</h3>
              <p className={styles['text-wrapper-25']}>
                Learn the basics of all 12 zodiac signs, their characteristics, and how they influence personality traits.
              </p>
              <div className={styles['frame-3']}>
                <button className={styles['frame-17']}>
                  <span className={styles['text-wrapper-26']}>Buy now</span>
                </button>
                <div className={styles['frame-wrapper']}>
                  <a href="#course-details" className={styles['frame-18']}>
                    <span className={styles['text-wrapper-27']}>View details</span>
                    <img
                      className={styles['img-2']}
                      src={iconParkRight7}
                      alt=""
                      aria-hidden="true"
                    />
                  </a>
                </div>
              </div>
            </div>
          </article>
          <article className={styles['div-6']}>
            <div className={styles['frame-19']}>
              <div className={styles['frame-14']}>
                <span className={styles['text-wrapper-22']}>₹ 490</span>
              </div>
              <div className={styles['frame-15']}>
                <span className={styles['text-wrapper-23']}>Beginner</span>
              </div>
            </div>
            <div className={styles['frame-16']}>
              <h3 className={styles['text-wrapper-24']}>Birth chart analysis</h3>
              <p className={styles['text-wrapper-25']}>
                Learn the basics of all 12 zodiac signs, their characteristics, and how they influence personality traits.
              </p>
              <div className={styles['frame-3']}>
                <button className={styles['frame-17']}>
                  <span className={styles['text-wrapper-26']}>Buy now</span>
                </button>
                <div className={styles['frame-wrapper']}>
                  <a href="#course-details" className={styles['frame-18']}>
                    <span className={styles['text-wrapper-27']}>View details</span>
                    <img
                      className={styles['img-2']}
                      src={iconParkRight7}
                      alt=""
                      aria-hidden="true"
                    />
                  </a>
                </div>
              </div>
            </div>
          </article>
          <article className={styles['div-6']}>
            <div className={styles['frame-20']}>
              <div className={styles['frame-21']}>
                <span className={styles['text-wrapper-22']}>₹ 490</span>
              </div>
            </div>
            <div className={styles['frame-16']}>
              <h3 className={styles['text-wrapper-28']}>Understanding planetary aspects</h3>
              <p className={styles['text-wrapper-25']}>
                Learn the basics of all 12 zodiac signs, their characteristics, and how they influence personality traits.
              </p>
              <div className={styles['frame-3']}>
                <button className={styles['frame-22']}>
                  <span className={styles['text-wrapper-26']}>Buy now</span>
                </button>
                <div className={styles['frame-wrapper']}>
                  <a href="#course-details" className={styles['frame-18']}>
                    <span className={styles['text-wrapper-27']}>View details</span>
                    <img
                      className={styles['img-2']}
                      src={iconParkRight7}
                      alt=""
                      aria-hidden="true"
                    />
                  </a>
                </div>
              </div>
            </div>
          </article>
            </section>
          </div>
            <button
              className={styles['course-nav-btn']}
              aria-label="Next course"
              onClick={nextCourse}
              style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '8px', display: 'none' }}
            >
              <img src={iconParkRight4} alt="" style={{ width: '32px', height: '32px' }} />
            </button>
          </div>

          {/* Dot navigation indicators for courses */}
          <div className={styles['course-dots']}>
            {[...Array(totalCourses)].map((_, index) => (
              <button
                key={index}
                className={`${styles['dot']} ${index === currentCourse ? styles['dot-active'] : ''}`}
                onClick={() => setCurrentCourse(index)}
                aria-label={`Go to course ${index + 1}`}
              />
            ))}
          </div>
        </div>
        <Link to="/astrology" className={styles['frame-23']}>
          <span className={styles['text-wrapper-29']}>Explore more</span>
          <img className={styles['img-2']} src={iconParkRight8} alt="" aria-hidden="true" />
        </Link>
        <h2 className={styles['heading-3']}>Frequently asked questions</h2>
        <section className={styles['div-flex']}>
          <details className={styles.FAQ} open={openFaqs.has('faq1')}>
            <summary className={styles.question} onClick={(e) => {e.preventDefault(); toggleFaq('faq1');}}>
              <p className={styles['what-astrology']}>What astrology services do you offer?<br />तुम्ही कोणत्या ज्योतिष सेवा देता?</p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq1') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq1') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  We offer horoscope readings, birth chart analysis, general consultations, and astrology courses.<br />आम्ही कुंडली वाचन, जन्मकुंडली विश्लेषण, सामान्य सल्ला आणि ज्योतिष अभ्यासक्रम देतो.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq2')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq2');}}>
              <p className={styles['what-astrology']}>How accurate are your predictions?<br />तुमच्या भाकितांची अचूकता किती आहे?</p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq2') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq2') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  With three generations of experience, our predictions are highly accurate, based on detailed birth chart
                  and planetary analysis.<br />तीन पिढ्यांच्या अनुभवामुळे, आमची भाकिते अत्यंत अचूक असतात, जन्मकुंडली आणि
                  ग्रहस्थितीच्या सखोल विश्लेषणावर आधारित.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq3')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq3');}}>
              <p className={styles['what-astrology']}>
                Do you provide online astrology consultations?<br />तुम्ही ऑनलाइन ज्योतिष सल्ला देता का?
              </p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq3') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq3') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  Yes, we offer online consultations via phone, video, or chat, along with in-person sessions.<br />होय,
                  आम्ही फोन, व्हिडिओ किंवा चॅटद्वारे ऑनलाइन तसेच प्रत्यक्ष भेटीचे सल्ले देतो.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq4')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq4');}}>
              <p className={styles['what-astrology']}>
                What details are required for an astrology reading?<br />ज्योतिष सल्ल्यासाठी कोणती माहिती आवश्यक आहे?
              </p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq4') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq4') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  Share your name, date of birth, time of birth, and place of birth for precise results.<br />अचूक
                  भाकितांसाठी तुमचे नाव, जन्मतारीख, जन्मवेळ आणि जन्मस्थान सांगा.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq5')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq5');}}>
              <p className={styles['what-astrology']}>
                Can astrology help with career and relationships?<br />ज्योतिष करिअर आणि नातेसंबंध सुधारण्यात मदत करू शकते
                का?
              </p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq5') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq5') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  Yes, astrology guides you in decisions, identifies opportunities, and suggests remedies for career and
                  relationship challenges.<br />होय, ज्योतिष तुमचे निर्णय योग्य घेण्यात मदत करते, संधी ओळखते आणि करिअर व
                  नातेसंबंधातील अडचणींसाठी उपाय सांगते.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq6')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq6');}}>
              <p className={styles['what-astrology']}>Do you give remedies for planetary issues?<br />ग्रहदोषांसाठी उपाय देता का?</p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq6') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq6') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  Yes, we recommend mantras, gemstones, and rituals to balance planetary influences.<br />होय, आम्ही
                  ग्रहांचा प्रभाव संतुलित करण्यासाठी मंत्र, रत्न आणि पूजाविधी सुचवतो.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq7')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq7');}}>
              <p className={styles['what-astrology']}>Is astrology linked to religion?<br />ज्योतिष धर्माशी संबंधित आहे का?</p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq7') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq7') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  Our astrology is spiritual yet practical, suitable for people of all faiths.<br />आमचे ज्योतिष आध्यात्मिक
                  असूनही व्यावहारिक आहे आणि सर्व धर्मातील लोकांसाठी उपयुक्त आहे.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq8')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq8');}}>
              <p className={styles['what-astrology']}>
                How do I book an astrology appointment?<br />मी ज्योतिष सल्ल्यासाठी अपॉइंटमेंट कशी बुक करू?
              </p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq8') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq8') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  Book your consultation directly on our website based on availability. Urgent sessions can be arranged on
                  request.<br />उपलब्धतेनुसार आमच्या वेबसाइटवरून तुमचे सल्ला अपॉइंटमेंट बुक करा. तातडीच्या सल्ल्यासाठी विशेष
                  व्यवस्था करता येईल.
                </p>
              </div>
            )}
          </details>
          <details className={styles['FAQ-2']} open={openFaqs.has('faq9')}>
            <summary className={styles['question-2']} onClick={(e) => {e.preventDefault(); toggleFaq('faq9');}}>
              <p className={styles['what-astrology']}>
                Will my personal information remain private?<br />माझी वैयक्तिक माहिती गोपनीय राहील का?
              </p>
              <img
                className={styles['img-2']}
                src={openFaqs.has('faq9') ? iconParkRight17 : iconParkRight9}
                alt=""
                aria-hidden="true"
              />
            </summary>
            {openFaqs.has('faq9') && (
              <div className={styles['we-offer-horoscope-wrapper']}>
                <p className={styles['we-offer-horoscope']}>
                  Absolutely. All your personal details, birth data, and consultation records are kept 100% confidential and
                  are never shared with anyone. We follow strict privacy and data protection practices.<br />नक्कीच. तुमची
                  सर्व वैयक्तिक माहिती, जन्मतारीख व जन्मकुंडलीची माहिती तसेच सल्लामसलतीची नोंद १००% गोपनीय ठेवली जाते आणि ती
                  कोणाशीही शेअर केली जात नाही. आम्ही कडक गोपनीयता व माहिती संरक्षण नियम पाळतो.
                </p>
              </div>
            )}
          </details>
        </section>
        <img className={styles.image} src={decorativeStar} alt="Decorative element" />
      </main>
      <Footer />
      {isSignInOpen && <SignInPopUp onClose={handleSignInClose} onNavigateToSignUp={handleSignUpOpen} />}
      {isSignUpOpen && <SignUpPopUp onClose={handleSignUpClose} onNavigateToSignIn={handleNavigateToSignIn} />}
    </>
  );
}